import * as icons from "../../../assets/icons/UnumSync/index";
import type { IconName } from "../../../assets/icons/UnumSync/index";

import { FC, SVGProps } from "react";

type IconProps = {
  name: IconName;
  viewBox?: string;
} & SVGProps<SVGSVGElement>;

const Icon: FC<IconProps> = ({ name, viewBox = "0 0 24 24", ...props }) => {
  const DynamicIcon = icons[name];
  if (DynamicIcon === undefined) {
    return null;
  }
  return (
    <DynamicIcon {...props} data-testid={name} viewBox={viewBox}></DynamicIcon>
  );
};

export default Icon;
